import { forwardRef } from "react";
import { BeaconRenderProps } from "react-joyride";

import tutorialStyle from "../tutorial.module.css";

export const CustomBeacon = forwardRef<HTMLButtonElement, BeaconRenderProps>((props, ref) => {
  return <span className={tutorialStyle.beacon} ref={ref} {...props} />;
});
